import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { selectProfessional as selectProfessionalAction } from 'actions/SelectedProfessionalActions';
import { clearServices as clearServicesAction } from 'actions/SelectedServicesActions';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { getSelectedProfessional } from 'selectors/professionals';

import { useAppContext } from 'hooks/context/useAppContext';

import { TProfessional } from 'types/appointment';

export const useTeamPage = () => {
  const { publicUser } = useAppContext();
  const router = useRouter();

  const selectedProfessional = useSelector(getSelectedProfessional);
  const dispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>();
  // Dispatch handlers
  const selectProfessional = (professional: TProfessional) =>
    dispatch(selectProfessionalAction(professional));
  const clearServices = () => dispatch(clearServicesAction());

  React.useEffect(() => {
    if (typeof window !== 'undefined' && router) {
      void router.prefetch('/book');
    }
  }, [router]);

  const handleBook = (professional: TProfessional) => {
    if (professional.guid !== selectedProfessional?.guid) {
      clearServices();
    }
    selectProfessional(professional);
    void router.push('/services');
  };

  const professionals = publicUser?.users
    ? publicUser.users.filter((item) => item.online_visible)
    : [];

  return {
    handleBook,
    professionals,
  };
};
